import { client } from '@/clientInstance';
import type { IProduct } from '@reolink-deps/reolink_web.fe.shared-modules';
import * as utils from '@reolink-web/utils';
export type TGetProductPriceResp = Record<number, {
    price: string;
    regularPrice: string;
}>;

export type TGetProductInfoByIdsResp = Record<string | number, IProduct>;

export type TGetProductInfoByKeysResp = Record<string | number, IProduct>;

export const getProductPrice = async (ids: number[], withLightingDeals?: boolean): Promise<TGetProductPriceResp> => {
    const res = await client.get<TGetProductPriceResp>(`new-product/prices?${withLightingDeals ? 'with_lighting_deals=1&' : ''}filter_id=${ids.join()}&no-mobile-redirection=1`);
    return res;
};

export const getProductInfo = async (key: string): Promise<IProduct[]> => {
    const res = await client.get<Record<string, IProduct>>(`new-product/batch?filter_name=${key}&no-mobile-redirection=1`);
    return Object.values(res);
};

export const getRecommendationProductInfo = async (key: string): Promise<IProduct[]> => {
    const res = await client.get<Record<string, IProduct>>(`new-product/batch?filter_name=${key}&currentProduct=${key}&no-mobile-redirection=1`);
    return Object.values(res);
};

export const getProductInfoById = async (id: number): Promise<IProduct[]> => {
    const res = await client.get<Record<string, IProduct>>(`new-product/batch?filter_id=${id}&no-mobile-redirection=1`);
    return Object.values(res);
};

export const getProductInfoByIds = async (ids: number[]): Promise<TGetProductInfoByIdsResp> => {
    const res = await client.get<TGetProductInfoByIdsResp>(`new-product/batch?filter_id=${ids.join()}&no-mobile-redirection=1`);
    return res;
};

export const getProductInfoByKey = async (key: string): Promise<TGetProductInfoByIdsResp> => {
    const res = await client.get<TGetProductInfoByIdsResp>(`new-product/batch?filter_name=${key}&currentProduct=${key}&recommendation=${key}&no-mobile-redirection=1`);
    return res;
};

export const getProductInfoMapByIds = async (
    ids: number[],
    getExtraInfo?: boolean,
    cache?: React.MutableRefObject<Record<number, IProduct>>
): Promise<Record<number, IProduct[]>> => {
    if (cache) {
        const unCachedIds = ids.filter(id => !cache.current[id]);
        if (!unCachedIds.length) {
            return ids.reduce<Record<number, IProduct[]>>((pre, cur) => {
                const productInfo = cache.current[cur];
                const subVersions = productInfo.subversion.versionProductIds;
                pre[cur] = [cache.current[cur], ...subVersions.map(id => cache.current[id])];
                return pre;
            }, {});
        }
        const url = `new-product/batch?filter_id=${unCachedIds.join()}${getExtraInfo ? `&extraFieldsProducts=${unCachedIds.join()}` : ''}&no-mobile-redirection=1`;

        const unCachedProductInfo = await client.get<TGetProductInfoByIdsResp>(url);

        if (cache.current) {
            cache.current = {
                ...cache.current,
                ...unCachedProductInfo
            };
        }

        return ids.reduce<Record<number, IProduct[]>>((pre, cur) => {
            const productInfo = cache.current[cur];
            const subVersions = productInfo.subversion.versionProductIds;
            pre[cur] = [cache.current[cur], ...subVersions.map(id => cache.current[id])];
            return pre;
        }, {});
    }
    else {

        const url = `new-product/batch?filter_id=${ids.join()}${getExtraInfo ? `&extraFieldsProducts=${ids.join()}` : ''}&no-mobile-redirection=1`;

        const allPoductInfo = await client.get<TGetProductInfoByIdsResp>(url);

        return ids.reduce<Record<number, IProduct[]>>((pre, cur) => {
            const productInfo = allPoductInfo[cur];
            const subVersions = productInfo.subversion.versionProductIds;
            pre[cur] = [allPoductInfo[cur], ...subVersions.map(id => allPoductInfo[id])];
            return pre;
        }, {});
    }

};

/**
 * 分批通过id获取产品数据，适合一起请求大量产品数据
 */
export const batchGetProductInfoByIds = async (ids: number[]): Promise<TGetProductInfoByIdsResp> => {
    const fetchGroup = [];
    for (let index = 0;index < ids.length;index += 20) {
        fetchGroup.push(ids.slice(index, index + 20));
    }
    const buildPool = new utils.Async.TaskPool(getProductInfoByIds, 3);
    const res = await Promise.all(fetchGroup.map(item => buildPool.call(item)));
    return res.reduce((pre, cur) => {
        return {
            ...pre,
            ...cur
        };
    }, {});
};
